import Container from "react-bootstrap/Container";
import ReactPlayer from 'react-player/lazy'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './blc_gallery_one.css';
import { Col, Row } from "react-bootstrap";


export const dummyVideos = [
  {
    url: 'https://fb.watch/g3pBHA5tai/',
  },
  {
    url: 'https://fb.watch/g3GTVCmOdL/',
  },
  {
    url: 'https://fb.watch/g3IdjM2Jg_/',
  },

]

const Blc_Gallery_Three = (props) => {

  // const sectionTitle = props.val.ovc_tag.split(' ');

  return (
    <section>
      <Container>
        <h2 className="text-start sectionHeading titles">
          <span className='me-2 titles-black'>OVC-BLC</span>
          <span>Facilities</span>
          {/* <span className='titles-black'>{sectionTitle[1]}</span>
          <span className=""> {sectionTitle[3]}</span> */}
        </h2>

        <Row className="gy-3 mb-5">
          {dummyVideos.map((video, idx) => (
            <Col xs={12} sm={6} md={4}>
              <ReactPlayer
                style={{ borderRadius: '5px', overflow: 'hidden' }}
                url={video.url}
                width='100%'
                height='100%'
                controls={true}
                // playing={true}
                loop={true}
                muted={true}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Blc_Gallery_Three;
